import React, {Component} from 'react'
import PrintPreview from '../PrintPreview'
import TyreStore from 'stores/TyreStore'

var NotificationSystem = require('react-notification-system');
const DEFAULT_ROW = 21
class PrintTyreRetireDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,data:{itemlist:this.newEmptyRow(DEFAULT_ROW)},dataList:[],page_title:'กำลังดึงข้อมูล..'}
    
    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('landscape');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    this.loadData()
  }

  newEmptyRow(number){
  	return new Array(number).fill(null).map((item,index)=>{
        return {tyre_retire_item_id:'',seq:'',tyrecode:'',mileage:'',vehicle_id:'',tyre_size:'',start_used_date:'',total_retread:'',last_tread_depth:'',last_tread_date:'',retire_date:undefined,remark:'',brand:'',model:'',vehicle_registration_no:'',detail:''}
    })
  }

  getPagination(data) {
    let newData = []
    let allData = []
    let checkRow = 0
    data.forEach(function(item,index) {
        if (checkRow<DEFAULT_ROW)
          checkRow++
          newData.push(item)

        if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
          allData.push(newData)
          checkRow = 0
          newData = []
        }
    })  
    return allData
  }

  loadData() {
  	let {data} = this.state
    this.setState({loading:true})
    TyreStore.loadPdfReportRetire(this.props.trNo,(result)=>{
 		data = result.data
 		if (data.itemlist!==undefined&&data.itemlist.length>0)
 			data.itemlist = data.itemlist.concat(this.newEmptyRow((DEFAULT_ROW-1)-data.itemlist.length))

 		this.setState({loading:false,data:data,dataList:this.getPagination(data.itemlist),report_title:'ไม่พบข้อมูล'})
 	},()=>{
        this.setState({loading:false,data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
     })
  }

  renderLogoUrl(logoUrl){
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    if(logoUrl!==undefined)
      return (<img src={imgUrl} />)
    else
      return ('')
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  renderBody(item,index) {
    let {data} = this.state
    return(
      <div>
      	<div>
            <table className='table table-print-bnp-invoice-doc-head' style={{marginTop:'10px'}}>
                <tr>
                    <td style={{width:'50%'}}>
                        เลขที่เอกสาร : {data.doc.tyre_repair_no}
                    </td>
                    <td style={{width:'50%'}} className='text-right'>
                        วันที่ : {data.doc.added_date}
                    </td>
                </tr>
                <tr>
                    <td>
                        ผู้ขอเบิก : {data.doc.request_by}
                    </td>
                    <td className='text-right'>
                        ชื่อผู้อนุมัติ : {data.doc.response_by}
                    </td>
                </tr>
                <tr>
                    <td colSpan={2}>
                        ทะเบียนรถ : {data.doc.vehicle_registration_no}
                    </td>
                </tr>
                <tr>
                    <td colSpan={2}>
                        คำอธิบาย : {data.doc.description}
                    </td>
                </tr>
            </table>
	    </div>	
        <div>
        	{this.renderTable(item,index)}
        </div>
      </div>
    )
  }

  renderTable(item,index) {
  	let {data} = this.state
  	return(
  		<table className='table table-print-bnp-invoice-doc'>
	        <tbody>
	          <tr>
                <td style={{width:'50px'}} className='text-center'>ลำดับ</td>
                <td style={{width:'100px'}} className='text-center'>หมายเลขยาง</td>
                <td style={{width:'100px'}} className='text-center'>ยี่ห้อ</td>
                <td style={{width:'100px'}} className='text-center'>รุ่น</td>
                <td style={{width:'80px'}} className='text-center'>ขนาดยาง</td>
                <td style={{width:'100px'}} className='text-center'>วันที่เริ่มใช้ยาง</td>
                <td style={{width:'80px'}} className='text-center'>จำนวนครั้ง<br/>หล่อดอก</td>
                <td style={{width:'100px'}} className='text-center'>ความลึกดอกยาง<br/>วัดครั้งสุดท้าย<br/>(ม.ม)</td>
                <td style={{width:'80px'}} className='text-center'>วัดดอกยางเมื่อวันที่</td>
                <td style={{width:'90px'}} className='text-center'>จำนวน ก.ม.<br/>ที่วิ่งได้</td>
                <td style={{width:'100px'}} className='text-center'>ทะเบียนรถ<br/>ใช้ยางครั้งสุดท้าย</td>
                <td style={{width:'100px'}} className='text-center'>ถอดไว้ที่คลัง<br/>เมื่อวันที่</td>
	          </tr>
              {this.renderRowData(item,index)}
              <tr>            
                <td colSpan={11} className='text-right'>รวมเป็นเงิน</td>
                <td className='text-right'>{this.getNumberFormat(data.doc.amount)}</td>
              </tr>
	        </tbody>
	    </table>
  	)
  }

  renderRowData(items,indexs) {
  	return(
        items.map((item,index)=>{
  			return(
                <tr key={index}>
                    <td className={'text-center'+(index==items.length-1?'':' bb-h')}>{item.seq==''?<br/>:(indexs*(DEFAULT_ROW-1))+index+1}</td>
                    <td className={'text-center'+(index==items.length-1?'':' bb-h')}>{item.tyrecode}</td>
                    <td className={'text-center'+( index==items.length-1?'':' bb-h')}>{item.brand}</td>
                    <td className={'text-center'+(index==items.length-1?'':' bb-h')}>{item.model}</td>
                    <td className={'text-center'+(index==items.length-1?'':' bb-h')}>{item.tyre_size==''?'':this.getNumberFormat(item.tyre_size)}</td>
                    <td className={'text-center'+(index==items.length-1?'':' bb-h')}>{item.start_used_date}</td>
                    <td className={'text-center'+(index==items.length-1?'':' bb-h')}>{item.total_retread==''?'':this.getNumberFormat(item.total_retread)}</td>
                    <td className={'text-center'+(index==items.length-1?'':' bb-h')}>{item.last_tread_depth==''?'':this.getNumberFormat(item.last_tread_depth)}</td>
                    <td className={'text-center'+(index==items.length-1?'':' bb-h')}>{item.last_tread_date}</td>
                    <td className={'text-center'+(index==items.length-1?'':' bb-h')}>{item.mileage==''?'':this.getNumberFormat(item.mileage)}</td>
                    <td className={'text-center'+(index==items.length-1?'':' bb-h')}>{item.vehicle_registration_no}</td>
                    <td className={'text-center'+(index==items.length-1?'':' bb-h')}>{item.retire_date}</td>
                </tr>
  			)
  		})
  	)
  }

  renderComponentPage(item,index) {
    let {data} = this.state

    return(
        <div className='font-print' key={index}>
            <div>
                <h2 className="text-center" style={{fontWeight:'bold'}}>{this.props.title}</h2>
                {/* <article className={"article-company "+data.logo_class}>
                    <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
                        {this.renderLogoUrl(data.logo_url)}
                    </div>
                    <section className="font-16" style={{width:'85%',paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
                        <strong>
                        <p style={{lineHeight:'0.7'}}>{data.company_name} (สำนักงานใหญ่)</p>           
                        <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
                        <p style={{lineHeight:'0.7'}}>เลขประจำตัวผู้เสียภาษีอากร {data.company_tax} โทร {data.company_tel}</p>              
                        </strong>
                    </section>
                </article> */}
                {this.renderBody(item,index)}
            </div>   
        </div>  
    )
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render() {
    let {loading,dataList} = this.state
    if (dataList.length==0) {
        return(
            <PrintPreview 
                loading={loading}
                leftBarTitle={this.props.title}
                size='landscape'
            >
                {this.renderNoData()}    
            </PrintPreview>
        )
    } else {
        return(
            <div>
                <PrintPreview
                    loading={loading}
                    leftBarTitle={this.props.title}
                    showPageNumber={false}
                    size='landscape'
                >
                    {
                        dataList.map((item,index)=> {
                            return(
                                this.renderComponentPage(item,index)
                            )
                        })	
                    }
                </PrintPreview>
                <NotificationSystem ref="notificationSystem" />
            </div>    
        )
    } 
  }
}  

PrintTyreRetireDoc.defaultProps = {
  title: 'ใบยางหมดอายุ',  
  mode: '1'
}
export default PrintTyreRetireDoc;


// WEBPACK FOOTER //
// ./src/view/print/tyre/PrintTyreRetireDoc.js